export default "__VITE_ASSET__CiY2me6Y__"